var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('audio',{ref:"soundNotification",attrs:{"src":require("@/assets/sounds/notification.mp3")}}),_c('RouterView'),_c('WebSocket',{on:{"orderApproved":_vm.emitSoundNotification}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }